import React, { Component, Fragment } from "react";
import { Row, Col, Container, Image } from "react-bootstrap";

import styles from "./Mission.module.scss";

import TestTube from "../../assets/png/TestTube.png";
import Mint from "../../assets/png/Mint2.png";

export default class Mission extends Component {
  render() {
    return (
      <section id={styles.Mission}>
        <Container id="OurMission" fluid>
          <Row>
            <Col
              lg={6}
              style={{ padding: 0, zIndex: 2 }}
              id={styles.MainContainer}
            >
              <Image src={Mint} id={styles.Mint} />
              <div className={styles.vl}></div>

              <div id={styles.TextBox}>
                <p id={styles.Header}>Our Mission</p>
                <br></br>
                <p id={styles.SubHeader}>BETTER TODAY. BETTER TOMORROW.</p>
                <br></br>
                <p id={styles.Content}>
                  We're taking carbon neutrality{" "}
                  <i>
                    <b>a step further</b>.
                  </i>{" "}
                  <br></br> <br></br> At Agrinol, we believe in{" "}
                  <b>
                    <i>reversing </i> greenhouse gas emissions
                  </b>{" "}
                  on a global scale. Our scientifically-proven, cutting-edge
                  technology <b> naturally captures emissions</b>, bringing you
                  a greener lifestyle today and for tomorrows to come.
                  <br></br> <br></br> Based in Ottawa, ON, Agrinol provides
                  products and services that combat climate change by absorbing
                  greenhouse gases from the atmosphere. We are working
                  tirelessly to significantly reduce and reverse emissions in
                  ways that are both natural and safe to the environment, and in
                  doing our part to support Canada’s commitment to achieve
                  net-zero emissions by 2050, per the Paris Agreement.
                </p>
                <div id={styles.GreyBox}>
                  <p id={styles.ContentBox}>
                    We are excited to announce that, in 2018, our patented
                    system for carbon dioxide capture and gas filtering was
                    approved by ISED (Innovation, Science, and Economic
                    Development Canada) and CIPO (Canadian Intellectual Property
                    Office), as well as copyrights for our proprietary carbon
                    tax calculations.
                  </p>
                </div>
              </div>
            </Col>
            <Col lg={6} id={styles.TestTubeContainer}>
              <Image src={TestTube} id={styles.TestTube} />
            </Col>
          </Row>
        </Container>
      </section>
    );
  }
}
